import { render } from "./Warehouses.vue?vue&type=template&id=74ab0910&ts=true"
import script from "./Warehouses.vue?vue&type=script&lang=ts"
export * from "./Warehouses.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__